import { useUnreadRequestCountData } from "@apis/requestHistory";
import BadgeDot from "@components/atoms/BadgeDot";
import VDBIcon, { IconsType, IconsVariant } from "@components/icons/VDBIcon";
import { PriceModes } from "@components/molecules/PriceModeCard/types";
import Routes from "@navigations/Routes";
import { useUserInfo } from "@redux/slices/userInfoSlice";
import { memo } from "react";
import { View } from "react-native";
import useScreenOptionsHooks from "../../hooks/useScreenOptionsHooks";
import { SpaceType } from "@components/atoms/Spacer/types";

const TabIcon = memo(({ color, icon, mainIconType, route, size }: any) => {
  const { theme } = useScreenOptionsHooks();
  const userInfo = useUserInfo();
  const hasBadge =
    userInfo.user.price_mode !== PriceModes.GREEN &&
    route.name === Routes.RequestHistoryNavigator &&
    !theme.isLargeScreen;

  const buyerData = useUnreadRequestCountData("buyer", "all", true, hasBadge);
  const sellerData = useUnreadRequestCountData("seller", "all", true, hasBadge);

  const showBadge =
    (sellerData?.data?.data?.count !== 0 &&
      sellerData?.data?.data?.count !== undefined) ||
    (buyerData?.data?.data?.count !== 0 &&
      buyerData?.data?.data?.count !== undefined);

  return (
    <View style={{ paddingTop: 0 }}>
      <VDBIcon
        name={icon}
        size={size ? size : SpaceType.Big}
        color={color}
        uri={icon}
        variant={
          mainIconType === IconsType.img_url
            ? IconsVariant.CustomUrl
            : IconsVariant.VDBCustom
        }
      />
      {hasBadge && showBadge && !userInfo.isPAUser() && (
        <BadgeDot isDesktop={theme.isLargeScreen} />
      )}
    </View>
  );
});

export default TabIcon;
